import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { PageLayoutsModule } from '../page-layouts/page-layouts.module';
import { LoadingPage } from './loading.page';

@NgModule({
    imports: [CommonModule, PageLayoutsModule, CoreUiModule],
    declarations: [LoadingPage],
    exports: [LoadingPage],
    providers: []
})
export class LoadingPageModule {}
